export default "__VITE_ASSET__DAGU_XR$__"